import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { SweetAlertService } from '../../../../services/sweet-alert/sweet-alert.service';
import { fuseAnimations } from '../../../../../core/animations';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { TranslationService } from '../../../../services/translation/translation.service';
import { IStudent } from '../../../../models/students/i-student';
import { ReportService } from '../../../../services/reports/report.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SchoolScheduleDataSource } from './school-schedule-data-source';
import { SchoolScheduleDatabase } from './school-schedule-database';
import { EventService } from '../../../../services/events/event.service';
import { AddEditSchoolScheduleComponent } from './add-edit-school-schedule/add-edit-school-schedule.component';
import { SchoolScheduleEvent } from '../../../../models/event/dto/schoolScheduleEvent';
import {ShiftService} from '../../../../services/shifts/shift.service';
import { JobTitle } from '../../../../models/jobtitle/jobtitle';


@Component({
    selector: 'fuse-school-schedule',
    templateUrl: './school-schedule.component.html',
    styleUrls: ['./school-schedule.component.scss'],
    animations: fuseAnimations
})
export class SchoolScheduleComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUI: NgBlockUI;
    displayedColumns = ['Title', 'StartDate', 'FinishDate', 'Type', 'Actions'];
    studentDatabase;
    dataSource: SchoolScheduleDataSource | null;
    public shifts = [];
    public shiftSelected = -1;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('filter') filter: ElementRef;
    confirmDialogRef: any;

    constructor(
        private activatedRoute: ActivatedRoute,
        private authenticationService: AuthenticationService,
        public dialog: MatDialog,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private eventService: EventService,
        private reportService: ReportService,
        private route: ActivatedRoute,
        private router: Router,
        private shiftService: ShiftService,
    ) {
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        this.studentDatabase = new SchoolScheduleDatabase(this.eventService);
        this.dataSource = new SchoolScheduleDataSource(this.studentDatabase, this.paginator, this.sort, this.shiftSelected);
        Observable.fromEvent(this.filter.nativeElement, 'keyup')
            .debounceTime(150)
            .distinctUntilChanged()
            .subscribe(() => {
                if (!this.dataSource) {
                    return;
                }
                this.dataSource.filter = this.filter.nativeElement.value;
            });
        Observable.combineLatest(
            this.shiftService.getAll()
        ).subscribe(([shifts]) => {
            this.shifts = shifts.slice();
            const todos = new JobTitle();
            todos.Id = -1;
            todos.Description = 'Todos';
            this.shifts.unshift(todos);
            this.blockUI.stop();
        });
    }

    ngOnDestroy() {

    }

    add() {
        const schoolScheduleEvent = new SchoolScheduleEvent();
        schoolScheduleEvent.StartDate = new Date(2018, 0, 1);
        schoolScheduleEvent.FinishDate = new Date(2018, 0, 1);
        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: 'new',
                schoolScheduleEvent: schoolScheduleEvent
            }
        };

        this.confirmDialogRef = this.dialog.open(AddEditSchoolScheduleComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('AddEditSchoolScheduleComponent > add > result', result);
            if (result !== true) {
                this.studentDatabase.add(result);
            }
        });
    }

    edit(schedule: any) {
        console.log('schedule', schedule);
        const schoolScheduleEvent = new SchoolScheduleEvent();
        schoolScheduleEvent.Id = schedule.Id;
        schoolScheduleEvent.Title = schedule.Title;
        schoolScheduleEvent.StartDate = schedule.StartDate;
        schoolScheduleEvent.FinishDate = schedule.FinishDate;
        schoolScheduleEvent.ShiftId = schedule.ShiftId;
        schoolScheduleEvent.EventTypeId = schedule.EventTypeId;
        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: 'edit',
                schoolScheduleEvent: schoolScheduleEvent
            }
        };

        this.confirmDialogRef = this.dialog.open(AddEditSchoolScheduleComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('AddEditSchoolScheduleComponent > edit > result', result);
            if (result) {
                schedule.Id = result.Id;
                schedule.Title = result.Title;
                schedule.StartDate = result.StartDate;
                schedule.FinishDate = result.FinishDate;
                schedule.ShiftId = result.ShiftId;
                schedule.EventTypeId = result.EventTypeId;
            }
        });
    }


    view(schedule: any) {
        const schoolScheduleEvent = new SchoolScheduleEvent();
        schoolScheduleEvent.Id = schedule.Id;
        schoolScheduleEvent.Title = schedule.Title;
        schoolScheduleEvent.StartDate = schedule.StartDate;
        schoolScheduleEvent.FinishDate = schedule.FinishDate;
        schoolScheduleEvent.ShiftId = schedule.ShiftId;
        schoolScheduleEvent.EventTypeId = schedule.EventTypeId;
        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: 'view',
                schoolScheduleEvent: schoolScheduleEvent
            }
        };

        this.confirmDialogRef = this.dialog.open(AddEditSchoolScheduleComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
        });
    }

    delete(schedule: any) {
        this.translationService.translate('LABELS.DELETION_CONFIRMATION_QUESTION', schedule.Title + ' ' + this.shifts.filter(s => s.Id == schedule.ShiftId)[0].Description, (res) => {
            this.sweetAlertService.question(this.translationService.confirmation, res, this.translationService.yes, this.translationService.no, () => {
                this.eventService.delete(schedule.Id).subscribe(response => {
                    console.log("dato =" + response.ResultCode);
                    if (response.ResultCode == 1) {
                        this.studentDatabase.delete(schedule);
                        const index = this.eventService.events.findIndex(s => s.Id == schedule.Id);
                        if (index >= 0) {
                            this.eventService.events.splice(index, 1);
                            delete this.eventService.eventsObject[schedule.Id];
                        }
                        this.sweetAlertService.success(this.translationService.success, this.translationService.deletedCorrectly, null);
                    } else {
                        this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                            this.sweetAlertService.error('Error', res, null);
                        });
                    }
                }, error => {
                    this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                        this.sweetAlertService.error('Error', res, null);
                    });
                });
            }, () => {
                console.log('FuseStudentComponent > delete > canceled');
            });
        });
    }

    filterSchedule(shiftId: number) {
        this.dataSource.filterSchedule(shiftId);
        // this.selectedDivisionId = shiftId;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/events/school-schedule/school-schedule.component.ts